import { connect } from "react-redux";

import GenericItemsView, { type GenericItemsViewProps } from "../../../../../../../../views/ItemsView/GenericItemsView";
import { type AppDispatch, type RootState } from "../../../../../../../Application/globaltypes/redux";
import { type SurveyUser } from "../../../../../types/models";
import { selectedItemsChanged } from "../../../../../state/slices/surveyUsersSlice";
import { surveysStateSelector } from "../../../../../state/surveyReducer";

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => {
  const edit = surveysStateSelector(state).edit;
  return {
    items: edit.users.items,
    isLoading: edit.users.isLoading,
    dataCount: edit.users.itemsCount,
    selectedIds: edit.users.selectedIds,
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onSelectedItemChanged: (ids: number[]) => dispatch(selectedItemsChanged(ids)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GenericItemsView as (props: GenericItemsViewProps<SurveyUser>) => React.ReactElement);
